import { ACCEPTED_KEYBOARD_EVENT_TYPES } from "../../scene/utils/events/KeyboardEventsController";
export var CoreEventEmitter = /* @__PURE__ */ ((CoreEventEmitter2) => {
  CoreEventEmitter2["CANVAS"] = "canvas";
  CoreEventEmitter2["DOCUMENT"] = "document";
  return CoreEventEmitter2;
})(CoreEventEmitter || {});
export const EVENT_EMITTERS = ["canvas" /* CANVAS */, "document" /* DOCUMENT */];
function elementFromEmitterType(emitter, canvas) {
  return emitter == "canvas" /* CANVAS */ ? canvas : document;
}
export class ViewerEventsController {
  constructor(viewer) {
    this.viewer = viewer;
    this._bound_listener_map_by_event_controller_type = /* @__PURE__ */ new Map();
  }
  updateEvents(eventsController) {
    const canvas = this.canvas();
    if (!canvas) {
      console.warn("no canvas found");
      return;
    }
    const controllerType = eventsController.type();
    let map = this._bound_listener_map_by_event_controller_type.get(controllerType);
    if (!map) {
      map = /* @__PURE__ */ new Map();
      this._bound_listener_map_by_event_controller_type.set(controllerType, map);
    }
    map.forEach((listenerWithData, eventType) => {
      for (let emitter of EVENT_EMITTERS) {
        const element = this._eventOwner({ emitter, type: eventType }, canvas);
        element.removeEventListener(eventType, listenerWithData.listener);
      }
    });
    map.clear();
    const listener = (event) => {
      this.processEvent(event, eventsController, canvas);
    };
    for (let eventData of eventsController.activeEventDatas()) {
      const eventOwner = this._eventOwner(eventData, canvas);
      eventOwner.addEventListener(eventData.type, listener);
      if (eventOwner != document) {
        if (ACCEPTED_KEYBOARD_EVENT_TYPES.includes(eventData.type)) {
          eventOwner.setAttribute("tabindex", "0");
        }
      }
      map.set(eventData.type, { listener, data: eventData });
    }
  }
  _eventOwner(eventData, canvas) {
    if (eventData.type == "resize") {
      return window;
    } else {
      return elementFromEmitterType(eventData.emitter, canvas);
    }
  }
  camera() {
    return this.viewer.camera();
  }
  canvas() {
    return this.viewer.canvas();
  }
  init() {
    if (!this.canvas()) {
      console.warn("no canvas found for eventsController");
      return;
    }
    this.viewer.scene().eventsDispatcher.traverseControllers((controller) => {
      this.updateEvents(controller);
    });
  }
  registeredEventTypes() {
    const list = [];
    this._bound_listener_map_by_event_controller_type.forEach((map) => {
      map.forEach((listener, eventType) => {
        list.push(eventType);
      });
    });
    return list;
  }
  dispose() {
    const canvas = this.canvas();
    this._bound_listener_map_by_event_controller_type.forEach((map) => {
      if (canvas) {
        map.forEach((listenerWithData, eventType) => {
          const eventOwner = this._eventOwner(listenerWithData.data, canvas);
          eventOwner.removeEventListener(eventType, listenerWithData.listener);
        });
      }
    });
  }
  processEvent(event, controller, canvas) {
    const eventContext = {
      viewer: this.viewer,
      event
    };
    controller.processEvent(eventContext);
  }
}
